import * as React from "react";
import "../../../gatsby-browser";
import statisticsData from "../../data/statistics.json";

class StudentStats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      statistics: statisticsData.statistics,
    };
  }

  componentDidMount() {
    // Counter animation is initialized globally in main.js
    // If needed, we can trigger it again when component mounts
    if (typeof window !== "undefined" && window.jQuery && window.jQuery.fn.counterUp) {
      // Re-initialize counter for elements in this component
      setTimeout(() => {
        window.jQuery('#student-stats [data-toggle="counter-up"]').counterUp({
          delay: 10,
          time: 2000,
        });
      }, 100);
    }
  }

  render() {
    const { statistics } = this.state;

    return (
      <>
        <section id="student-stats" className="wow fadeIn" style={{ padding: "60px 0", backgroundColor: "#fff" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="row">
                  {statistics.map((stat) => (
                    <div
                      key={stat.id}
                      className="col-lg-4 col-md-6 col-sm-6 mb-4 wow bounceInUp"
                      data-wow-duration="1.4s"
                    >
                      <div
                        className="box"
                        style={{
                          border: "2px solid #e74c3c",
                          borderRadius: "8px",
                          padding: "2rem",
                          height: "100%",
                          backgroundColor: "#fff",
                          transition: "all 0.3s ease-in-out",
                          display: "flex",
                          alignItems: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                          <div
                            style={{
                              fontSize: "3rem",
                              color: "#e74c3c",
                              marginRight: "1.5rem",
                              minWidth: "60px",
                              textAlign: "center",
                            }}
                          >
                            <i className={stat.icon} aria-hidden="true"></i>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontSize: "2.5rem",
                                fontWeight: "bold",
                                color: "#1d89e4",
                                lineHeight: "1.2",
                                marginBottom: "0.5rem",
                              }}
                            >
                              <span data-toggle="counter-up">{stat.value}</span>
                              {stat.suffix}
                            </div>
                            <div
                              style={{
                                fontSize: "1rem",
                                color: "#283d50",
                                fontWeight: "500",
                                lineHeight: "1.4",
                              }}
                            >
                              {stat.label}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default StudentStats;

